module.exports = __webpack_public_path__ + "static/media/kr.e0c2b4f5.png";